import { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { NavContext } from '../util/navContext';
import "./styling/home.css";
import "./styling/home-s.css";
import insta from "./assets/insta.svg";
import mail from "./assets/mail.svg";
import phone from "./assets/phone.svg";
import pinOrange from "./assets/pin-orange.svg";
import AOS from "aos";

import xCross from '../components/assets/x.svg';

// grote afbeeldingen
import homeImages from "../generated/images/homeManifest";

function Home({ onLoadComplete }) {
  
  const [isLoaded, setIsLoaded] = useState(false);
  const [logoLoaded, setLogoLoaded] = useState(false);
  const [reserveSelect, isReserveSelect] = useState(false);

  const [isMobile, setIsMobile] = useState(
    window.matchMedia("(max-width: 1200px)").matches
  );

  const { handleLinkClick, isHome } = useContext(NavContext);

  // Scroll to the top of the page
  useEffect(() => {
    window.scrollTo(0, 0); 
  }, []);

  const responsiveSizes = [480, 768, 1200, 1920];

  const buildSrcSet = (image, format) =>
    responsiveSizes.map((width) => `${image[format][width]} ${width}w`).join(", ");

  // preload images with light version for fast page load
  const getPreloadImageUrl = (image) => {
    if (window.innerWidth <= 600) return image.webp[480];
    if (window.innerWidth <= 1200) return image.webp[768];
    return image.webp[1920];
  };

  const ginBgImage = homeImages["gin-bg"];
  const liquorImage = homeImages.liqourNewest;
  const restaurantImage = homeImages.restraunt;
  const bottegaImage = homeImages.bottega;
  const satiataImage = homeImages.satiata;

  const urls = [
    getPreloadImageUrl(ginBgImage),
    getPreloadImageUrl(liquorImage),
    getPreloadImageUrl(restaurantImage),
    getPreloadImageUrl(bottegaImage),
    getPreloadImageUrl(satiataImage),
  ];

  // preload images
  function finishLoading() {
    setIsLoaded(true);
    document.documentElement.style.overflow = "auto";
    AOS.refreshHard();
    onLoadComplete?.();
  }

  // preload images
  useEffect(() => {
    document.documentElement.style.overflow = "hidden";

    // const preloadLogo = new Promise((resolve) => {
    //   const img = new Image();
    //   img.src = splashLogo;
    //   img.onload = resolve;
    //   img.onerror = resolve; // nooit blokkeren
    // });

    const preloadImages = urls.map(
      (url) =>
        new Promise((resolve) => {
          const img = new Image();
          img.src = url;
          img.onload = resolve;
          img.onerror = resolve;
        })
    );

    Promise.all([...preloadImages]).then(() => {
      setIsLoaded(true);
      document.documentElement.style.overflow = "auto";
      AOS.refreshHard();
      onLoadComplete?.();
    });
  }, []);

  return (
    <div id="homeWrapper">

      { reserveSelect && (
        <div id="menuSelectorBox">
          <div className="menuSelectorWrapper">
            <img onClick={() => isReserveSelect(false)} src={xCross} alt="x"></img>

            <h3>Waar wil je een tafel reserveren?</h3>

            <div className="menuSelectButtons">
               <a
                  href="https://restaurant-pulcinos.lurch.app/reservation/"
                  rel="noreferrer"
                  target="_blank"
                >
                  <button className="btn-pulci" >Pulcinos</button>
                </a>
                <a
                  href="https://pulcinos.lurch.app/reservation/"
                  rel="noreferrer"
                  target="_blank"
                >
                  <button className="btn-satiata" >Satiata</button>
                </a>
            </div>
          </div>
        </div>
      )}      

      <div id="splashScreen" className={isLoaded ? "fade-out" : ""}> 
           <img data-aos="zoom-in" src="/logoLemons.webp" alt=""
            loading="eager"
            decoding="sync"/>           
      </div>

      <div id="homeOverlay">
        <div></div>
      </div>

      <div id="homeContent">
        <div className="highlights">
          <Link
            onClick={() => handleLinkClick(isHome)}
            className="hightlightsLink"
            to="/liquors#liquorBox"
            style={{ textDecoration: "none" }}
          >
            <div id="liqourDiv">
              <picture>
                <source
                  type="image/avif"
                  srcSet={buildSrcSet(liquorImage, "avif")}
                  sizes="(max-width: 1200px) 100vw, 25vw"
                />
                <source
                  type="image/webp"
                  srcSet={buildSrcSet(liquorImage, "webp")}
                  sizes="(max-width: 1200px) 100vw, 25vw"
                />
                <img
                  src={liquorImage.jpg[1200]}
                  srcSet={buildSrcSet(liquorImage, "jpg")}
                  sizes="(max-width: 1200px) 100vw, 25vw"
                  alt=""
                  loading="eager"
                  decoding="async"
                />
              </picture>
              <h2>Liquors</h2>
            </div>
          </Link>

          <Link
          onClick={() => handleLinkClick(isHome)}
            className="hightlightsLink"
            to="/restaurant#restrauntAnchor"
            style={{ textDecoration: "none" }}
          >
            <div id="restrauntDiv">
              <picture>
                <source
                  type="image/avif"
                  srcSet={buildSrcSet(restaurantImage, "avif")}
                  sizes="(max-width: 1200px) 100vw, 25vw"
                />
                <source
                  type="image/webp"
                  srcSet={buildSrcSet(restaurantImage, "webp")}
                  sizes="(max-width: 1200px) 100vw, 25vw"
                />
                <img
                  src={restaurantImage.jpg[1200]}
                  srcSet={buildSrcSet(restaurantImage, "jpg")}
                  sizes="(max-width: 1200px) 100vw, 25vw"
                  alt=""
                  loading="eager"
                  decoding="async"
                />
              </picture>
              <h2>Restaurant</h2>
            </div>
          </Link>

          <a
            className="hightlightsLink"
            href="https://bottega-tilburg.nl/"
            target="_blank"
            style={{ textDecoration: "none" }}
          >
            <div id="liqourStoreDiv">
              <picture>
                <source
                  type="image/avif"
                  srcSet={buildSrcSet(bottegaImage, "avif")}
                  sizes="(max-width: 1200px) 100vw, 25vw"
                />
                <source
                  type="image/webp"
                  srcSet={buildSrcSet(bottegaImage, "webp")}
                  sizes="(max-width: 1200px) 100vw, 25vw"
                />
                <img
                  src={bottegaImage.jpg[1200]}
                  srcSet={buildSrcSet(bottegaImage, "jpg")}
                  sizes="(max-width: 1200px) 100vw, 25vw"
                  alt=""
                  loading="eager"
                  decoding="async"
                />
              </picture>
              <h2>Bottega</h2>
            </div>
          </a>

          <a
            className="hightlightsLink"
            href="https://satiatarestaurant.nl/"
            target="_blank"
            style={{ textDecoration: "none" }}
          >
            <div id="satiataDiv">
              <picture>
                <source
                  type="image/avif"
                  srcSet={buildSrcSet(satiataImage, "avif")}
                  sizes="(max-width: 1200px) 100vw, 25vw"
                />
                <source
                  type="image/webp"
                  srcSet={buildSrcSet(satiataImage, "webp")}
                  sizes="(max-width: 1200px) 100vw, 25vw"
                />
                <img
                  src={satiataImage.jpg[1200]}
                  srcSet={buildSrcSet(satiataImage, "jpg")}
                  sizes="(max-width: 1200px) 100vw, 25vw"
                  alt=""
                  loading="eager"
                  decoding="async"
                />
              </picture>
              <h2>Satiata</h2>
            </div>
          </a>
        </div>

        <div className="btnBox">

          {isMobile ? (
            <>
            
            <button onClick={() => isReserveSelect(true)}>Reserveer een Tafel</button>

            <div className="contactSplitter">

            <div className="btnWrapper">
            <div className="addresses">
              <a
                href="https://maps.app.goo.gl/uMM7iNZJsabxVUm5A"
                rel="noreferrer"
                target="_blank"
              >
                <div className="addressWrapper">
                  <div className="addressImageWrapper">
                    <img src={pinOrange} alt=""></img>
                  </div>
                  <div className="textBox">
                    <span>
                      <strong>Pulcinos Tilburg</strong>
                    </span>
                    <span>Piushaven 20B</span>
                  </div>
                </div>
              </a>
              <a
                href="https://maps.app.goo.gl/eSXfhx15C5z9GpJv7"
                rel="noreferrer"
                target="_blank"
              >
                <div className="addressWrapper">
                  <div className="addressImageWrapper">
                    <img src={pinOrange} alt=""></img>
                  </div>
                  <div className="textBox">
                    <span>
                      <strong>Satiata</strong>
                    </span>
                    <span>Piushaven 5</span>
                  </div>
                </div>
              </a>
              <a
                  href="https://maps.app.goo.gl/8HuG6o8p1bM2G4zX8"
                  rel="noreferrer"
                  target="_blank"
                >
              <div className="addressWrapper">
                <div className="addressImageWrapper">
                  <img src={pinOrange} alt=""></img>
                </div>
                <div className="textBox">
                  <span>
                    <strong>Bottega</strong>
                  </span>
                  <span>Heuvelstraat 131</span>
                </div>
              </div>
              </a>
            </div>
            </div>

            <div className="contactWrapper">
            <div className="contactDiv">
            <a href="tel:0135914906">
              <div className="contactSection">
                <div className="addressImageWrapper">
                  <img src={phone} alt=""></img>
                </div>
                <span>
                  <strong>013 591 4906</strong>
                </span>
              </div>
              </a>
              <a href="mailto:contact@pulcinos.nl">
              <div className="contactSection">
                <div className="addressImageWrapper">
                  <img src={mail} alt=""></img>
                </div>
                <span>
                  <strong>contact@pulcinos.nl</strong>
                </span>
              </div>
              </a>
            </div>
            <a
                href="https://www.instagram.com/pulcinostilburg/"
                target="_blank"
                rel="noopener noreferrer"
              >
            <div className="instaLogoWrapper">             
                <img id="instaLogo" src={insta} alt="instagram"></img>             
            </div>
            </a>
          </div>
          </div>
            </>
          ) : (
            <>

          <div className="btnWrapper">
            <div className="addresses">
              <a
                href="https://maps.app.goo.gl/uMM7iNZJsabxVUm5A"
                rel="noreferrer"
                target="_blank"
              >
                <div className="addressWrapper">
                  <div className="addressImageWrapper">
                    <img src={pinOrange} alt=""></img>
                  </div>
                  <div className="textBox">
                    <span>
                      <strong>Pulcinos Tilburg</strong>
                    </span>
                    <span>Piushaven 20B</span>
                  </div>
                </div>
              </a>
              <a
                href="https://maps.app.goo.gl/eSXfhx15C5z9GpJv7"
                rel="noreferrer"
                target="_blank"
              >
                <div className="addressWrapper">
                  <div className="addressImageWrapper">
                    <img src={pinOrange} alt=""></img>
                  </div>
                  <div className="textBox">
                    <span>
                      <strong>Satiata</strong>
                    </span>
                    <span>Piushaven 5</span>
                  </div>
                </div>
              </a>
              <a
                  href="https://maps.app.goo.gl/8HuG6o8p1bM2G4zX8"
                  rel="noreferrer"
                  target="_blank"
                >
              <div className="addressWrapper">
                <div className="addressImageWrapper">
                  <img src={pinOrange} alt=""></img>
                </div>
                <div className="textBox">
                  <span>
                    <strong>Bottega</strong>
                  </span>
                  <span>Heuvelstraat 131</span>
                </div>
              </div>
              </a>
            </div>
          </div>
          
          <button onClick={() => isReserveSelect(true)}>Reserveer een Tafel</button>
       
          <div className="contactWrapper">
            <div className="contactDiv">
            <a href="tel:0135914906">
              <div className="contactSection">
                <div className="addressImageWrapper">
                  <img src={phone} alt=""></img>
                </div>
                <span>
                  <strong>013 591 4906</strong>
                </span>
              </div>
              </a>
              <a href="mailto:contact@pulcinos.nl">
              <div className="contactSection">
                <div className="addressImageWrapper">
                  <img src={mail} alt=""></img>
                </div>
                <span>
                  <strong>contact@pulcinos.nl</strong>
                </span>
              </div>
              </a>
            </div>
            <a
                href="https://www.instagram.com/pulcinostilburg/"
                target="_blank"
                rel="noopener noreferrer"
              >
            <div className="instaLogoWrapper">             
                <img id="instaLogo" src={insta} alt="instagram"></img>             
            </div>
            </a>
          </div>
          </>
          )}
        </div>
      </div>
    </div>
  );
}

export default Home;
